module.exports = __webpack_public_path__ + "static/media/off games.2ea91477.svg";